import { render, staticRenderFns } from "./PdvCallClosed.vue?vue&type=template&id=fa5cbf4a"
import script from "./PdvCallClosed.vue?vue&type=script&lang=js"
export * from "./PdvCallClosed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports